import { useEffect } from 'react'
import { APP_VERSION_POLL_MS } from '@/utils/appVersion'

/** Interval + focus/visibility polling for soft updates. */
export function useVersionPollEffects(checkForUpdate) {
  useEffect(() => {
    if (import.meta.env.DEV) return undefined
    void checkForUpdate()
    const timer = window.setInterval(() => void checkForUpdate(), APP_VERSION_POLL_MS)
    const onVisible = () => {
      if (document.visibilityState === 'visible') void checkForUpdate()
    }
    document.addEventListener('visibilitychange', onVisible)
    window.addEventListener('focus', checkForUpdate)
    return () => {
      window.clearInterval(timer)
      document.removeEventListener('visibilitychange', onVisible)
      window.removeEventListener('focus', checkForUpdate)
    }
  }, [checkForUpdate])
}
